(function () {
  var root = document.documentElement;
  var onScroll = function () { root.classList.toggle('is-scrolled', window.scrollY > 40); };
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = root.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-compare]').forEach(function (c) {
    var r = c.querySelector('input');
    var set = function () { c.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', set); set();
  });
  /* compteurs */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.fact strong').forEach(function (el) {
    var m = el.textContent.match(/\d+/);
    if (!m || reduce) return;
    var target = parseInt(m[0], 10);
    el.innerHTML = el.textContent.replace(m[0], '<span class="count">' + m[0] + '</span>');
    var c = el.querySelector('.count');
    c.style.minWidth = c.offsetWidth + 'px';
    c.textContent = '0';
    var run = function () {
      var t0 = null, d = 1800;
      var step = function (t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / d, 1), e = 1 - Math.pow(1 - p, 3);
        c.textContent = Math.round(target * e);
        if (p < 1) requestAnimationFrame(step); else c.textContent = target;
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { c.textContent = target; return; }
    var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); o.disconnect(); } }, { threshold: 0.6 });
    o.observe(el);
  });
  /* slider plein écran */
  document.querySelectorAll('[data-slider]').forEach(function (s) {
    var bgs = [].slice.call(s.querySelectorAll('.fs-bg')), copies = [].slice.call(s.querySelectorAll('.fs-slide')), cards = [].slice.call(s.querySelectorAll('.fs-card'));
    var n = bgs.length, cur = 0, cnt = s.querySelector('.fs-count'), bar = s.querySelector('.fs-bar i');
    if (n < 2) return;
    var pad = function (v) { return (v < 10 ? '0' : '') + v; };
    function go(i) {
      cur = (i + n) % n;
      bgs.forEach(function (e, k) { e.classList.toggle('is-active', k === cur); });
      copies.forEach(function (e, k) { e.classList.toggle('is-active', k === cur); });
      cards.forEach(function (c, k) { c.style.order = (k - cur + n) % n; c.hidden = (k === cur); });
      cnt.textContent = pad(cur + 1);
      bar.classList.remove('run'); void bar.offsetWidth; if (!reduce) bar.classList.add('run');
    }
    s.querySelectorAll('.fs-arrow').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
    cards.forEach(function (c) { c.addEventListener('click', function () { go(parseInt(c.getAttribute('data-index'), 10)); }); });
    bar.addEventListener('animationend', function () { go(cur + 1); });
    var phone = window.matchMedia && window.matchMedia('(max-width: 700px)').matches;
    go(0);
    if (phone && 'IntersectionObserver' in window) {
      bar.classList.remove('run');
      var seen = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { go(0); seen.disconnect(); } }, { threshold: 0.35 });
      seen.observe(s);
    }
  });
  /* domaines : carrousel à 3 cartes */
  document.querySelectorAll('[data-domains]').forEach(function (r) {
    var cards = [].slice.call(r.querySelectorAll('.dom-card')), n = cards.length, cur = n > 1 ? 1 : 0;
    if (n < 3) return;
    function go(i) {
      cur = (i + n) % n;
      cards.forEach(function (c, k) {
        var d = (k - cur + n) % n, pos = d === 0 ? 0 : (d === 1 ? 1 : -1);
        c.classList.toggle('is-center', pos === 0);
        c.style.order = pos + 1;
      });
    }
    r.querySelectorAll('.dom-controls .rev-arrow').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
    cards.forEach(function (c, k) {
      c.addEventListener('click', function (e) {
        if (window.innerWidth > 900 && !c.classList.contains('is-center')) { e.preventDefault(); go(k); }
      });
    });
    go(1);
  });
  /* partenaires : couleur au toucher (téléphone) */
  document.querySelectorAll('.partners li').forEach(function (li) {
    var t = null;
    li.addEventListener('touchstart', function () { clearTimeout(t); document.querySelectorAll('.partners li.is-on').forEach(function (o) { o.classList.remove('is-on'); }); li.classList.add('is-on'); }, { passive: true });
    li.addEventListener('touchend', function () { t = setTimeout(function () { li.classList.remove('is-on'); }, 1500); }, { passive: true });
    li.addEventListener('touchcancel', function () { li.classList.remove('is-on'); }, { passive: true });
  });
  /* galerie photo : agrandissement */
  var lb = null;
  function lbShow(items, i) {
    if (!lb) {
      lb = document.createElement('div'); lb.className = 'lb'; lb.hidden = true;
      lb.innerHTML = '<button class="lb-x" type="button" aria-label="Fermer">×</button><button class="lb-p" type="button" aria-label="Précédent">←</button><figure><img alt=""><figcaption></figcaption></figure><button class="lb-n" type="button" aria-label="Suivant">→</button>';
      document.body.appendChild(lb);
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.className === 'lb-x') lb.hidden = true; });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') lb.hidden = true;
        if (e.key === 'ArrowRight') lb.querySelector('.lb-n').click();
        if (e.key === 'ArrowLeft') lb.querySelector('.lb-p').click();
      });
    }
    var cur = i;
    function paint() {
      var b = items[cur];
      lb.querySelector('img').src = b.getAttribute('data-full');
      lb.querySelector('img').alt = b.getAttribute('data-caption') || '';
      lb.querySelector('figcaption').textContent = b.getAttribute('data-caption') || '';
    }
    lb.querySelector('.lb-p').onclick = function () { cur = (cur - 1 + items.length) % items.length; paint(); };
    lb.querySelector('.lb-n').onclick = function () { cur = (cur + 1) % items.length; paint(); };
    paint(); lb.hidden = false;
  }
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var items = [].slice.call(g.querySelectorAll('.gal-btn'));
    items.forEach(function (b, i) { b.addEventListener('click', function () { lbShow(items, i); }); });
  });
  /* avis */
  document.querySelectorAll('[data-reviews]').forEach(function (r) {
    var cards = [].slice.call(r.querySelectorAll('.rev-card')), n = cards.length, cur = 0, t = null;
    if (n < 2) return;
    function go(i) {
      cur = (i + n) % n;
      cards.forEach(function (c, k) {
        var d = (k - cur + n) % n, pos = d === 0 ? 0 : (d === 1 ? 1 : (d === n - 1 ? -1 : 9));
        c.classList.toggle('is-center', pos === 0);
        c.hidden = pos === 9;
        c.style.order = pos + 1;
      });
    }
    function auto() { clearInterval(t); if (!reduce) t = setInterval(function () { go(cur + 1); }, 7000); }
    r.querySelectorAll('.rev-arrow').forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); auto(); }); });
    r.addEventListener('mouseenter', function () { clearInterval(t); });
    r.addEventListener('mouseleave', auto);
    var fit = function () {
      var track = r.querySelector('.rev-track');
      var ref = cards.filter(function (c) { return c.offsetWidth > 0; })[0];
      var w = ref ? ref.getBoundingClientRect().width : 340, h = 0;
      cards.forEach(function (c) { c.style.minHeight = ''; });
      cards.forEach(function (c) {
        var k = c.cloneNode(true);
        k.removeAttribute('hidden'); k.classList.remove('is-center');
        k.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;display:block;transform:none;order:0;flex:none;width:' + w + 'px;min-height:0';
        track.appendChild(k); h = Math.max(h, k.getBoundingClientRect().height); track.removeChild(k);
      });
      cards.forEach(function (c) { c.style.minHeight = Math.ceil(h) + 'px'; });
      go(cur);
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('load', fit);
    window.addEventListener('resize', fit);
    fit(); auto();
  });
  var els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (e) { io.observe(e); });
})();
